import React from 'react';

const PaymentMethod = ({ method, className, showIcon, showMode, liveMode }) => {
  if (!method) return null;

  let methodIcon = '';
  let methodName = '';

  if (method.toLowerCase().startsWith('access code')) {
    methodIcon = '🔑';
    methodName = 'Access Code';
  } else {
    switch (method.toLowerCase()) {
      case 'stripe':
        methodIcon = '💳';
        methodName = 'Stripe';
        break;
      case 'stripe.multibanco':
        methodIcon = '🏧';
        methodName = 'Multibanco';
        break;
      case 'stripe.ideal':
        methodIcon = '🏦';
        methodName = 'iDEAL';
        break;
      case 'paypal':
        methodIcon = '🅿';
        methodName = 'PayPal';
        break;
      case 'razorpay':
        methodIcon = '🇮🇳';
        methodName = 'Razorpay';
        break;
      case 'coinpayments':
        methodIcon = '⚡';
        methodName = 'CoinPayments';
        break;
      case 'free trial':
        methodIcon = '🆓';
        methodName = 'Free trial';
        break;
      case 'skrill':
        methodIcon = '🌐';
        methodName = 'Skrill';
        break;
      case 'paystack':
        methodIcon = '🇳🇬🇬🇭🇿🇦';
        methodName = 'Paystack';
        break;
      case 'telegram':
        methodIcon = '⭐';
        methodName = 'Telegram Stars';
        break;
      default:
        methodIcon = '';
        methodName = '';
    }
  }

  return (
    <div className={`inline-block ${className ? className : ''}`}>
      {showIcon && <div className="inline-block w-8 text-center">{methodIcon}</div>}
      <div className="inline-block">{methodName}</div>
      {showMode && !liveMode && <div className="badge -yellow ml-2">test</div>}
    </div>
  );
};

export default PaymentMethod;
